import {
  CButton, CContainer,
  CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle,
  CRow
} from '@coreui/react'
import React, { useEffect, useState } from 'react'
import ChapterItems from '../components/ChapterItems'
import VerseItems from '../components/VerseItems'

export default function ChapterModal(props) {
  const book = props.book
  const bookRef = props.bookRef
  const [selectedChapter, setSelectedChapter] = useState()

  return (
    <>
      <CModal
        show={props.show}
        size="xl"
        centered={true}
        onClose={() => props.onClose()}
        closeOnBackdrop={false}
        className="modal-w100"
        style={{ height: '95vh', width: '100%' }}
      >
        <CModalHeader closeButton>
          <CModalTitle>
            #{book.number} {book.name}
          </CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CContainer fluid>
            <CRow>
              <ChapterItems
                book={book}
                bookRef={bookRef}
                selectedChapter={selectedChapter}
                onSelect={(chapter) => {
                  setSelectedChapter(chapter)
                }}
              />
              {
                selectedChapter &&
                <VerseItems
                  book={book}
                  bookRef={bookRef}
                  chapter={selectedChapter}
                />
              }
            </CRow>
          </CContainer>
        </CModalBody>
        <CModalFooter>
          <CButton color="danger" variant="outline" className="btn-sm pl-4 pr-4"
            onClick={() => props.onClose()}>Close</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}



